var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParametrizacao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "parametrizacao",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parametrizacao_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.8,59.2c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12S47.2,59.2,53.8,59.2z M53.8,43.2c2.2,0,4,1.8,4,4 c0,2.2-1.8,4-4,4s-4-1.8-4-4C49.8,45,51.6,43.2,53.8,43.2z M57.6,79.7h8v56.1h-8V79.7z M46.1,63.6h43.6v8H46.1 c-2.2,0-3.9,1.8-3.9,4v23.1h7.6v37.1h-8v-29.1h-7.6v-31c0-3.2,1.2-6.2,3.4-8.5C39.8,64.9,42.8,63.6,46.1,63.6z M97.7,79.7h39.1v8 H97.7V79.7z M136.8,63.6v8H97.7v-8H136.8z M81.7,79.7h8v8h-8V79.7z M97.7,95.7h39.1v8H97.7V95.7z M81.7,95.7h8v8h-8V95.7z  M97.7,111.8h39.1v8H97.7V111.8z M81.7,111.8h8v8h-8V111.8z M97.7,127.8h39.1v8H97.7V127.8z M81.7,127.8h8v8h-8V127.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParametrizacao);
export default __webpack_public_path__ + "static/media/parametrizacao.49cb04524abd259e6c4d6c787c49f5a8.svg";
export { ForwardRef as ReactComponent };